import React from 'react';
import SafeIcon from '../../common/SafeIcon';

export default function StepLocation({ data, updateData, onNext, onPrev }) {
  const isGame = data.type === 'game';
  
  const durationsStandard = [
    { id: '1u', label: '1 uur (Inspiratiesessie)' },
    { id: '2u', label: '2 uur' },
    { id: 'halve_dag', label: 'Halve dag' },
    { id: 'hele_dag', label: 'Volledige dag' },
  ];

  const durationsGame = [
    { id: '6u', label: '6 uur' },
  ];

  const durations = isGame ? durationsGame : durationsStandard;

  React.useEffect(() => {
    if (isGame && data.duration !== '6u') {
      updateData({ duration: '6u' });
    }
  }, [isGame]);

  const isValid = data.duration && data.location;

  return (
    <div className="space-y-6 animate-fadeIn">
      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-4 text-left">3. Hoelang mag de workshop duren?</h3>
        <div className="grid grid-cols-2 gap-3">
          {durations.map((dur) => (
            <button
              key={dur.id}
              onClick={() => updateData({ duration: dur.id })}
              className={`p-3 rounded-lg border text-center transition-all ${
                data.duration === dur.id
                  ? 'border-[#154A48] bg-white text-[#154A48] font-medium'
                  : 'border-gray-200 hover:border-[#154A48]/30'
              }`}
            >
              {dur.label}
            </button>
          ))}
        </div>
      </div>

      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-4 text-left">4. Waar wenst u de workshop te organiseren?</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <button
            onClick={() => updateData({ location: 'inhouse' })}
            className={`p-4 rounded-xl border-2 text-left transition-all ${
              data.location === 'inhouse'
                ? 'border-[#154A48] bg-white text-[#154A48]'
                : 'border-gray-200 hover:border-[#154A48]/30'
            }`}
          >
            <div className="flex items-center gap-2 mb-2">
              <SafeIcon name="Home" className={data.location === 'inhouse' ? 'text-[#154A48]' : 'text-gray-500'} />
              <span className="font-semibold">Inhouse (bij u)</span>
            </div>
            <p className="text-sm text-gray-600">Wij komen naar uw eigen gekozen locatie.</p>
          </button>

          <button
            onClick={() => updateData({ location: 'wetteren' })}
            className={`p-4 rounded-xl border-2 text-left transition-all ${
              data.location === 'wetteren'
                ? 'border-[#154A48] bg-white text-[#154A48]'
                : 'border-gray-200 hover:border-[#154A48]/30'
            }`}
          >
            <div className="flex items-center gap-2 mb-2">
              <SafeIcon name="MapPin" className={data.location === 'wetteren' ? 'text-[#154A48]' : 'text-gray-500'} />
              <span className="font-semibold">Locatie Wetteren</span>
            </div>
            <p className="text-sm text-gray-600 mb-2">Inclusief zaalhuur en catering.</p>
            <div className="bg-[#E9F1F0] p-2 rounded border border-[#154A48]/10">
              <p className="text-[10px] uppercase tracking-wider font-bold text-[#154A48] mb-1">Standaard catering:</p>
              <p className="text-xs text-gray-500 italic">Koffie/water/thee en broodjeslunch (andere opties bespreekbaar).</p>
            </div>
          </button>
        </div>
      </div>

      <div className="flex gap-3 pt-4">
        <button
          onClick={onPrev}
          className="px-6 py-3 rounded-lg font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors"
        >
          Terug
        </button>
        <button
          onClick={onNext}
          disabled={!isValid}
          className="flex-1 bg-[#154A48] text-white py-3 rounded-lg font-bold hover:bg-[#0E3432] disabled:opacity-50 transition-colors"
        >
          Volgende stap
        </button>
      </div>
    </div>
  );
}